module["exports"] = [
  "Mr.",
  "Mrs.",
  "Ms.",
  "Miss",
  "Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/name/prefix.js
// module id = 2101
// module chunks = 2